/* Photo-upload grid for products where the number of photos is a variant.

   The grid renders every slot the largest variant needs and hides the rest.
   Hidden slots are disabled as well as hidden - a hidden but enabled file input
   still posts, which would attach photos the customer did not order.

   Slot count follows the selected variant. Rather than guess the variant
   picker's input names, which differ between Dawn versions, this reads the
   hidden 'id' input on the product form - that is the one field Dawn always
   keeps current - and maps it through a variant-id-to-count table rendered by
   Liquid. */

(function () {
  if (window.__eoPhotoGrid) return;
  window.__eoPhotoGrid = true;

  function parseCounts(grid) {
    try {
      return JSON.parse(grid.getAttribute('data-counts') || '{}');
    } catch (e) {
      return {};
    }
  }

  function wantedCount(grid) {
    var fallback = parseInt(grid.getAttribute('data-default') || '0', 10) || 0;
    var formId = grid.getAttribute('data-form');
    var form = formId ? document.getElementById(formId) : null;
    if (!form) return fallback;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return fallback;

    var counts = parseCounts(grid);
    var found = counts[String(idInput.value)];
    return typeof found === 'number' ? found : fallback;
  }

  function clearSlot(slot) {
    var input = slot.querySelector('input[type="file"]');
    var tile = slot.querySelector('.eo-photogrid__tile');
    if (input) {
      input.value = '';
    }
    if (tile) {
      var url = tile.getAttribute('data-object-url');
      if (url) {
        URL.revokeObjectURL(url);
        tile.removeAttribute('data-object-url');
      }
      tile.style.backgroundImage = '';
    }
    slot.classList.remove('is-filled');
  }

  function preview(slot) {
    var input = slot.querySelector('input[type="file"]');
    var tile = slot.querySelector('.eo-photogrid__tile');
    if (!input || !tile) return;

    var file = input.files && input.files[0];
    if (!file) {
      clearSlot(slot);
      return;
    }

    var old = tile.getAttribute('data-object-url');
    if (old) URL.revokeObjectURL(old);

    var url = URL.createObjectURL(file);
    tile.setAttribute('data-object-url', url);
    tile.style.backgroundImage = 'url("' + url + '")';
    slot.classList.add('is-filled');
  }

  function status(grid) {
    var wrap = grid.parentNode;
    var el = wrap ? wrap.querySelector('[data-photo-status]') : null;
    if (!el) return;

    var slots = grid.querySelectorAll('.eo-photogrid__slot:not([hidden])');
    var filled = grid.querySelectorAll('.eo-photogrid__slot:not([hidden]).is-filled');
    var total = slots.length;
    var done = filled.length;

    if (done === 0) {
      el.textContent = 'Add ' + total + ' photo' + (total === 1 ? '' : 's');
    } else if (done < total) {
      el.textContent = done + ' of ' + total + ' added';
    } else {
      el.textContent = 'All ' + total + ' photos added';
    }
    el.classList.toggle('is-complete', done === total && total > 0);
  }

  function sync(grid) {
    var want = wantedCount(grid);
    var slots = grid.querySelectorAll('.eo-photogrid__slot');

    for (var i = 0; i < slots.length; i++) {
      var on = i < want;
      var input = slots[i].querySelector('input[type="file"]');
      if (!on && slots[i].classList.contains('is-filled')) clearSlot(slots[i]);
      slots[i].hidden = !on;
      if (input) input.disabled = !on;
    }

    status(grid);
  }

  function syncAll() {
    var grids = document.querySelectorAll('[data-photo-grid]');
    for (var i = 0; i < grids.length; i++) sync(grids[i]);
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var slot = target.closest('.eo-photogrid__slot');
    if (slot && target.type === 'file') {
      preview(slot);
      var grid = slot.closest('[data-photo-grid]');
      if (grid) status(grid);
      return;
    }

    // Anything else that changed might have been the variant picker. Dawn
    // updates the hidden id input in its own change handler, so re-read on the
    // next tick, and again shortly after in case the section re-rendered.
    setTimeout(syncAll, 0);
    setTimeout(syncAll, 200);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var clear = target.closest('[data-photo-clear]');
    if (!clear) return;

    event.preventDefault();
    var slot = clear.closest('.eo-photogrid__slot');
    if (!slot) return;

    clearSlot(slot);
    var grid = slot.closest('[data-photo-grid]');
    if (grid) status(grid);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }

  document.addEventListener('shopify:section:load', syncAll);
})();
